import {
  BackdropProps,
  Button,
  Stack,
  Typography,
} from "@/common/styles/style";
import Dialog from "@/molecules/dialog";
import { styles } from "./style";

interface DeleteConfirmModalProps {
  open: boolean;
  deleteMessage: string;
  handleDelete?: (type?: string) => void;
  onClose: () => void;
  backdrop?: Partial<BackdropProps>;
  type?: string;
}

export default function DeleteConfirmModal({
  open,
  deleteMessage,
  backdrop,
  type,
  handleDelete,
  onClose,
}: DeleteConfirmModalProps) {
  return (
    <Dialog
      open={open}
      title="テンプレート削除確認"
      onClose={onClose}
      contentChildren={
        <Typography variant="body1" sx={styles.text}>
          {type === "account" ? (
            <>
              {deleteMessage}アカウントが削除されます。
              <br />
              本当に退会しますか？
            </>
          ) : (
            <>
              {deleteMessage}を削除します。
              <br />
              よろしいですか？
            </>
          )}
        </Typography>
      }
      actionsChildren={
        <Stack direction="row" spacing={2}>
          <Button variant="outlined" size="small">
            <Typography variant="button" onClick={onClose}>
              キャンセル
            </Typography>
          </Button>
          <Button variant="contained" size="small">
            <Typography variant="button" onClick={() => handleDelete?.()}>
              削除
            </Typography>
          </Button>
        </Stack>
      }
      BackdropProps={backdrop}
    />
  );
}
